export default {"src":"/_next/static/media/sad_24.5921d889.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};